export default "__VITE_ASSET__B70vjhxe__"